/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../../infra/hooks';
import { actionRequiredService } from '../../../api/services/actionRequiredService';
import {
  setARActions,
  setARData,
  setARDataTemp,
} from '../../../infra/aggregates/actionRequired/actionRequiredSlice';
import { dashboardService } from '../../../api/services/dashboardService';
import { setEditAccess, setRoleInfo, setViewAccess } from '../../../infra/aggregates/UserRoleInfo';
import _ from 'lodash';
interface PropForAr {
  setArValFunc: any;
  setAllDepartments?: any;
  setAllLeaveTypes?: any;
}
function DTOActionRequiredViewer({
  setArValFunc,
  setAllLeaveTypes,
}: PropForAr) {
  const dispatch = useAppDispatch();
  const actionRequired_value = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredValue,
  );
  const company_id = useAppSelector((state) => state.authSlice.company_id);

  // ***** Core Handlers
  const actionRequired_event_name = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredEventName,
  );
  const actionRequired_value_from_date = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredFromDate,
  );
  const actionRequired_value_to_date = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredToDate,
  );

  const user_id = useAppSelector((state) => state.authSlice.user_id);

  useEffect(() => {
    if (actionRequired_value) {
      setArValFunc(actionRequired_value); // Setting value for heading
    }
  }, [actionRequired_value]);

  useEffect(() => {
    if (actionRequired_event_name == 'leave') {
      actionRequiredService
        .getActionRequiredDetail(
          actionRequired_event_name,
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
          localStorage.getItem('emplang'),
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
      actionRequiredService.getLeaveTypes(company_id).then((res: any) => {
        if (res) {
          setAllLeaveTypes(res?.data);
        }
      });
    } else if (actionRequired_event_name == 'leave encashment') {
      actionRequiredService
        .getLeaveEncashment(
          actionRequired_event_name,
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
          localStorage.getItem('emplang'),
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data?.data));
            dispatch(setARDataTemp(res?.data?.data));

            res?.data?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
      actionRequiredService.getLeaveTypes(company_id).then((res: any) => {
        if (res) {
          setAllLeaveTypes(res?.data);
        }
      });
    } else if (actionRequired_event_name == 'promotions') {
      actionRequiredService
        .getAllPromotionsActionRequired(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'award') {
      actionRequiredService
        .getAllAwards(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'transfer') {
      actionRequiredService
        .getAllTransfers(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'warning') {
      actionRequiredService
        .getAllWarning(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'complaint') {
      actionRequiredService
        .getAllComplaint(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'resignation') {
      actionRequiredService
        .getAllResignations(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'termination') {
      actionRequiredService
        .getAllTerminations(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'claims') {
      actionRequiredService
        .getAllClaims(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'overtime') {
      actionRequiredService
        .getAllOvertime(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'offCycle') {
      actionRequiredService
        .getAllOffcycle(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'recurringPayment') {
      actionRequiredService
        .getAllRecurringPayment(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'setSalary') {
      actionRequiredService
        .getAllSetSalary(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'salaryAdjustment') {
      actionRequiredService
        .getAllSalaryAdjustment(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'payrollSettlement') {
      actionRequiredService
        .getAllPayrollSettlement(user_id)
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'employeeTicket') {
      actionRequiredService
        .getAllEmpTickets(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'fnf') {
      actionRequiredService
        .getAllFnF(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'letter request') {
      actionRequiredService
        .getAllLetterRequest(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    } else if (actionRequired_event_name == 'Comp Off') {
      actionRequiredService
        .getAllCompOffRequest(
          user_id,
          actionRequired_value_from_date,
          actionRequired_value_to_date,
        )
        .then((res: any) => {
          if (res?.response == 'success') {
            dispatch(setARData(res?.data));
            dispatch(setARDataTemp(res?.data));

            res?.data.map((x: any) => {
              if (x?.step) {
                dispatch(setARActions(x?.step?.actions));
              }
            });
          }
        })
        .catch((err) => console.log(err));
    }
  }, [
    actionRequired_event_name,
    actionRequired_value_from_date,
    actionRequired_value_to_date,
  ]);
  const userId = useAppSelector((state: any) => state.authSlice.user_id);
  const locale = localStorage.getItem('emplang');
  async function getUserData(){
    dashboardService
    .getUserInfo(userId,locale)
    .then((res:any)=>{
      function checkPermission(res: any, permissionName: any) {
        return _.map(res, function(e) {
            const filter = e.role.role_has_permissions;
            const access = _.filter(filter,function(permissionObj: any){ 
              return permissionObj?.permission?.name === permissionName
            });
            return access;
        });
      }
    const editPermissions = checkPermission(res, 'Employee AD Edit Access');
    const viewPermissions = checkPermission(res, 'Employee AD View Access');
    dispatch(setRoleInfo(res[0].role))
    if (editPermissions.some(data=> data.length>0) || viewPermissions.some(data=> data.length>0)){
      dispatch(setViewAccess(true))
    }else{
      dispatch(setViewAccess(false))
    }
    if (editPermissions.some(data=> data.length>0)) {
      dispatch(setEditAccess(true))
    }else{
      dispatch(setEditAccess(false))
    }
    })
  }
  useEffect(() => {
    getUserData();
  }, []);

  return <></>;
}
export default DTOActionRequiredViewer;
